/** Option-C primary-button tokens — separate from palette.secondary.main (checkbox/accent). */
export const COLOR_SECONDARY_BTN = '#CC9433';
export const COLOR_SECONDARY_BTN_TEXT = '#2B1B06';
export const COLOR_SECONDARY_BTN_HOVER = '#C2892B';
export const COLOR_SECONDARY_BTN_ACTIVE = '#B67E24';
export const COLOR_SECONDARY_BTN_DISABLED = '#EFDCB0';
export const COLOR_SECONDARY_BTN_DISABLED_TEXT = '#7B6942';

/** MuiButton containedSecondary — do not drive from palette.secondary.dark/light. */
export const containedSecondaryOverrides = {
  backgroundColor: COLOR_SECONDARY_BTN,
  color: COLOR_SECONDARY_BTN_TEXT,
  '--variant-containedBg': COLOR_SECONDARY_BTN,
  '--variant-containedColor': COLOR_SECONDARY_BTN_TEXT,
  '&:hover': {
    backgroundColor: COLOR_SECONDARY_BTN_HOVER,
    '--variant-containedBg': COLOR_SECONDARY_BTN_HOVER,
  },
  '&:active': {
    backgroundColor: COLOR_SECONDARY_BTN_ACTIVE,
    '--variant-containedBg': COLOR_SECONDARY_BTN_ACTIVE,
  },
  '&.Mui-disabled': {
    backgroundColor: COLOR_SECONDARY_BTN_DISABLED,
    color: COLOR_SECONDARY_BTN_DISABLED_TEXT,
    '--variant-containedBg': COLOR_SECONDARY_BTN_DISABLED,
    '--variant-containedColor': COLOR_SECONDARY_BTN_DISABLED_TEXT,
  },
};
